import {Columns} from 'compob2b-table';

export const YANDEX_FORM: Columns[] = [
  {
    key: 'token',
    title: 'OAuth token Яндекса',
    placeholder: '',
    type: 'input',
    required: true,
    grid: false,
    formly: true
  },
];
